module.exports = __webpack_public_path__ + "static/media/Foodcourt-2-mobile.a36e28d1.webp";